// extracted by mini-css-extract-plugin
module.exports = {"root":"InstalmentField_root__2XZXp","actions":"InstalmentField_actions__1F5Ww"};